'use client';
import { useEffect, useRef } from 'react';
import drawShape from '@/lib/visualisers/shapes';

interface ShapeOptions {
    sides: number;
    radius: number;
    width: number;
    height: number;
    fillColor: string;
    showAngles: boolean;
    angleOverride: string;
}

interface ShapeVisualiserProps {
    type: string;
    options: ShapeOptions;
}

export default function ShapeVisualiser({ type, options }: ShapeVisualiserProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        drawShape(c, { type, ...options, size: 400 });
    }, [type, options]);

    return (
        <div className="flex w-full max-w-[400px] flex-col items-center rounded-lg border-[0.5px] border-line bg-white p-5">
            <canvas
                ref={canvasRef}
                aria-label={`A ${type} shape`}
                className="h-auto w-full"
            />
            <div className="mt-3 text-sm capitalize text-muted">
                Visualising a{' '}
                <strong className="font-medium text-ink">{type.replace('-', ' ')}</strong>
            </div>
        </div>
    );
}
